import { connect } from 'react-redux';

import { getMembership } from '@techstyle/react-accounts';
import { getSession } from '@techstyle/redux-core';

import { trackHomepageCarousel } from '../../actions/pagesRendered';

import FullScreenCarouselWithHooks from './FullScreenCarousel';

export function mapStateToProps(state) {
  return {
    isLoggedIn: getSession(state).isLoggedIn,
    membershipPrice: getMembership(state).price,
  };
}

export default connect(mapStateToProps, {
  trackHomepageCarousel,
})(FullScreenCarouselWithHooks);
